import { motion } from "framer-motion";
import { FadeUp, Overline } from "../components/Motion";
import { GALLERY } from "../data/content";

const Portfolio = () => (
  <section id="work" data-testid="portfolio-section" className="bg-[#050505] py-28 md:py-40">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <FadeUp>
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div>
            <Overline>Selected Work</Overline>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6">
              The <span className="italic">portfolio</span>.
            </h2>
          </div>
          <p className="text-[#A1A1AA] max-w-xs">
            A cross-section of recent frames — from the studio to the front row.
          </p>
        </div>
      </FadeUp>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 max-w-[800px]">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={i}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: (i % 2) * 0.1 }}
            className={`group relative overflow-hidden rounded-sm ${g.span}`}
          >
            <div className={`overflow-hidden ${g.ratio}`}>
              <img
                src={g.src}
                alt={g.label}
                className={`h-full w-full ${g.fit || "object-cover"} ${g.pos || "object-center"} scale-105 group-hover:scale-110 brightness-[0.8] group-hover:brightness-100 transition-[transform,filter] duration-[900ms] ease-out`}
              />
            </div>
            <figcaption className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-500 bg-gradient-to-t from-black/80 to-transparent">
              <span className="text-white text-sm uppercase tracking-wider">{g.label}</span>
              <span className="text-[#F5A623] font-mono text-xs">/ {String(i + 1).padStart(2, "0")}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Portfolio;
